import React, { FC } from 'react';

import styles from './index.module.sass';

interface DeclineProps {
  onClick: () => void;
}

const Decline: FC<DeclineProps> = ({ onClick }) => (
  <button className={styles.button} type="button" onClick={onClick}>
    Decline Offer
  </button>
);

export default Decline;
